export class IngredientSideEffectReactionContentModel {
    public ingredientSideEffectReactionId: number;
    public langId: number;
    public description: string;
}